var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-table", {
        ref: "table",
        staticClass: "q-mt-lg",
        attrs: {
          data: _vm.enrollments,
          columns: _vm.columns_awaiting_cancellation,
          "row-key": "id",
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestAwaitingCancellation
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c("q-td", { key: "full_name", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.full_name) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "code", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.code) + "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "author", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.author) + "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      { key: "created_date", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.fDate(props.row.created_date)) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "attachments",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              round: "",
                              flat: "",
                              icon: "fas fa-exclamation",
                              color: "secondary",
                              disabled: !props.row.attachments.length
                            },
                            on: {
                              click: function($event) {
                                return _vm.openEvidence(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("show_evidences")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "actions", attrs: { props: props } },
                      [
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "primary",
                              icon: "fas fa-clipboard-list"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$router.push({
                                  name: "appointment",
                                  params: { id: props.row.presential_event }
                                })
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("training")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "positive",
                              icon: "fas fa-user-check",
                              disable: !_vm.is_admin
                            },
                            on: {
                              click: function($event) {
                                return _vm.approveDialog(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("approve")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "q-btn",
                          {
                            attrs: {
                              flat: "",
                              round: "",
                              color: "negative",
                              icon: "fas fa-user-times",
                              disable: !_vm.is_admin
                            },
                            on: {
                              click: function($event) {
                                return _vm.reproveDialog(props.row)
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("reprove")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "q-td",
                      { key: "observation", attrs: { props: props } },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.observation) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          on: { ok: _vm.approve },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.closeDialogs()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("approve") },
                    on: {
                      click: function($event) {
                        return _vm.approve()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_approve,
            callback: function($$v) {
              _vm.confirm_approve = $$v
            },
            expression: "confirm_approve"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("approve")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_approve_cancellation")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.confirm_approve_observation,
                  callback: function($$v) {
                    _vm.confirm_approve_observation = $$v
                  },
                  expression: "confirm_approve_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          on: { ok: _vm.reprove },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.closeDialogs()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("reprove") },
                    on: {
                      click: function($event) {
                        return _vm.reprove()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_reprove,
            callback: function($$v) {
              _vm.confirm_reprove = $$v
            },
            expression: "confirm_reprove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_reprove_cancellation")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.confirm_reprove_observation,
                  callback: function($$v) {
                    _vm.confirm_reprove_observation = $$v
                  },
                  expression: "confirm_reprove_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          model: {
            value: _vm.attachments_view,
            callback: function($$v) {
              _vm.attachments_view = $$v
            },
            expression: "attachments_view"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("evidences")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "q-list",
                {
                  staticClass: "q-mt-md",
                  attrs: { dense: "", bordered: "", padding: "", separator: "" }
                },
                _vm._l(_vm.attachments_to_view, function(attachment, index) {
                  return _c(
                    "q-item",
                    { key: index },
                    [
                      _c("q-item-side", {
                        attrs: { icon: "fas fa-check", color: "positive" }
                      }),
                      _c("q-item-main", [
                        _c(
                          "a",
                          {
                            staticClass: "text-black",
                            attrs: { href: attachment, target: "_blank" }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$truncateLink(attachment))
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }